'use client';
import type { ReactElement } from 'react';
import { PRISM_ANIMATION_ROTATE, PRISM_DEFAULT_MAX_DPR } from './prismConstants';
import type { PrismProps } from './prismTypes';
import { usePrismRenderer } from './usePrismRenderer';
export type { PrismFpsSample } from './prismTypes';
const Prism = ({ height = 3.5, baseWidth = 5.5, animationType = PRISM_ANIMATION_ROTATE, glow = 1, offset = { x: 0, y: 0 }, noise = 0.5, transparent = true, scale = 3.6, hueShift = 0, colorFrequency = 1, hoverStrength = 2, inertia = 0.05, bloom = 1, suspendWhenOffscreen = false, timeScale = 0.5, maxDpr = PRISM_DEFAULT_MAX_DPR, paused = false, onError, onFpsSample, }: PrismProps): ReactElement => {
    const containerRef = usePrismRenderer({
        height,
        baseWidth,
        animationType,
        glow,
        offset,
        noise,
        transparent,
        scale,
        hueShift,
        colorFrequency,
        hoverStrength,
        inertia,
        bloom,
        suspendWhenOffscreen,
        timeScale,
        maxDpr,
        paused,
        onError,
        onFpsSample,
    });
    return ( 
  <div data-el="Prism/Root" ref={containerRef} style={{ width: '100%', height: '100%', position: 'relative' }}/>)
  ;
};
export default Prism;
